export default __webpack_public_path__ + "34cc9ceeb872df45e4fcd290b4710b8a.svg";